import { render, staticRenderFns } from "./details_item_index.vue?vue&type=template&id=7871041d&"
import script from "./details_item_index.vue?vue&type=script&lang=js&"
export * from "./details_item_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports